import styled, { css } from 'styled-components';
import { Box, Button, ButtonAppearance, ButtonSize } from '@bechtel/gds';
import { TimesheetStatus } from '@bechtel/types';

export const CrewHeaderContainerStyled = styled(Box).attrs({
  p: { sm: '400' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
  `};
`;

export const CrewHeadertyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  flexGrow: { sm: 1 },
})`
  ${({ theme }) => css`
    background-image: linear-gradient(275deg, ${theme.colors.bechtel.blue[1000]}, ${theme.colors.bechtel.blue[800]});
    border-radius: ${theme.radii[200]};
  `}
`;

interface CrewTimesheetStatusStyledProps {
  status: TimesheetStatus;
}

function getCrewTimesheetStatusStyles({ status }: CrewTimesheetStatusStyledProps) {
  switch (status) {
    case TimesheetStatus.IN_PROGRESS || TimesheetStatus.NOT_STARTED:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
      `;
    case TimesheetStatus.APPROVED || TimesheetStatus.SUBMITTED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
      `;
  }
}

export const CrewTimesheetStatusStyled = styled(Box)<CrewTimesheetStatusStyledProps>`
  ${({ theme }) => css`
    border-top-left-radius: ${theme.radii[200]};
    border-bottom-left-radius: ${theme.radii[200]};
    width: ${theme.spacings[400]};
    height: 82px;
  `}
  ${getCrewTimesheetStatusStyles};
`;

export const HeaderButtonStyled = styled(Button).attrs({
  size: ButtonSize.MEDIUM,
  appearance: ButtonAppearance.SECONDARY,
})`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    width: auto;
  `}
`;

export const DividerStyled = styled(Box).attrs({ ml: { sm: '500' } })`
  ${({ theme }) => css`
    width: ${theme.spacings[100]};
    background-color: ${theme.colors.white};
  `}
`;
